import React from 'react';
import styled from 'styled-components';
import BulkActionButton from './BulkActionButton';

const BulkActions = ({ 
  filteredProfiles, 
  adminOrgs, 
  onSuccess,
  disabled = false
}) => {
  // Get the first organization ID (assuming the user is admin of this org)
  const organizationId = adminOrgs && adminOrgs.length > 0 ? adminOrgs[0].id : null;
  
  if (!organizationId) {
    return null;
  }
  
  return (
    <BulkActionsContainer>
      <BulkActionButton 
        filteredProfiles={filteredProfiles}
        organizationId={organizationId}
        onSuccess={onSuccess}
        disabled={disabled}
      />
    </BulkActionsContainer>
  );
};

const BulkActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin: 12.5px 0 10px;
`;

export default BulkActions; 